import { useUniforms } from '@/lib/hooks'
import { formatCurrency } from '@/lib/utils'
import { PageHero } from '@/components/layout/PageHero'

export function UniformsPage() {
  const { data: uniforms = [] } = useUniforms()
  return (
    <>
      <PageHero
        eyebrow="Cosmos Uniforms &amp; Merchandise"
        title="Shop."
        intro="Match kits, training gear, and Cosmos F.C. merchandise. Contact registration for team-order pricing and bulk discounts."
        image="https://cosmosfc.org/wp-content/uploads/2022/03/CFCFU.jpg"
        crumbs={[{ label: 'Shop' }]}
      />
      <section className="py-20">
        <div className="container-narrow">
          <div className="grid gap-5 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
            {uniforms.map((u) => (
              <article key={u.id} className="rounded-2xl overflow-hidden border border-border bg-card hover:shadow-lg hover:-translate-y-0.5 transition-all">
                <div className="aspect-square bg-pitch-800 relative overflow-hidden">
                  <img src={u.image} alt={u.name} loading="lazy" className="w-full h-full object-cover" />
                  {u.featured && (
                    <span className="absolute top-3 left-3 rounded bg-cosmos-gold px-2 py-1 text-[10px] font-bold uppercase tracking-widest text-pitch-900">
                      Team Set
                    </span>
                  )}
                </div>
                <div className="p-4">
                  <div className="font-display text-lg uppercase leading-tight">{u.name}</div>
                  <div className="mt-1 text-xs text-muted-foreground">Sizes: {u.sizes.join(' · ')}</div>
                  <div className="mt-3 flex items-center justify-between">
                    <div className="font-display text-2xl text-cosmos-green num">{formatCurrency(u.price)}</div>
                    <button className="text-xs font-bold uppercase tracking-widest text-cosmos-green hover:underline">Add →</button>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </>
  )
}
